function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#333333",
  d: "M37.697,26.27H32v2.102h5.697c0.584,0,1.052-0.474,1.052-1.045C38.749,26.744,38.281,26.27,37.697,26.27z"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#333333",
  d: "M42.098,20.824h-13.15c-0.579,0-1.051,0.471-1.051,1.055c0,0.58,0.472,1.052,1.051,1.052h13.15 c0.58,0,1.052-0.472,1.052-1.052C43.149,21.295,42.678,20.824,42.098,20.824z"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#333333",
  d: "M42.098,15.428h-13.15c-0.579,0-1.051,0.473-1.051,1.049c0,0.579,0.472,1.05,1.051,1.05h13.15 c0.58,0,1.052-0.471,1.052-1.05C43.149,15.9,42.678,15.428,42.098,15.428z"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#333333",
  d: "M48.619,6.994c0,0-6.609-6.551-6.758-6.687C41.688,0.148,41.336,0,41.118,0c-0.142,0-18.071,0-18.071,0 C22.471,0,22,0.469,22,1.047v21.029h2.103V2.099h15.973v5.702c0,0.586,0.468,1.059,1.043,1.059h5.708v23.043H32V34h15.876 c0.58,0,1.048-0.467,1.048-1.048V7.742C48.924,7.458,48.809,7.195,48.619,6.994z M42.171,6.756V3.578l3.171,3.178H42.171z"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#333333",
  d: "M36.967,11.041c0.722-0.614,1.479-1.188,2.271-1.714c-1.521-0.937-2.802-2.224-3.731-3.751 c-1.522,0.966-2.824,2.246-3.819,3.748c0.443,0.623,1.853,2.02,1.853,2.02c0.549,0.467,1.144,0.88,1.777,1.232 C35.733,12.149,36.967,11.041,36.967,11.041z"
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#333333",
  d: "M30,43.952V25.123c0-0.576-0.468-1.047-1.047-1.047H1.048C0.467,24.076,0,24.547,0,25.123v18.829 C0,44.532,0.467,45,1.048,45h27.904C29.533,45,30,44.532,30,43.952z M2.097,42.902V26.179h25.805l0.002,16.724H2.097z"
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 5.097,
  y: 29.179,
  fill: "#333333",
  width: 8,
  height: 10
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#333333",
  d: "M20.674,34.624h-4.749c-0.579,0-1.052,0.475-1.052,1.057c0,0.571,0.473,1.045,1.052,1.045h4.749 c0.584,0,1.053-0.474,1.053-1.045C21.727,35.099,21.258,34.624,20.674,34.624z"
});

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#333333",
  d: "M25.074,29.179h-9.149c-0.579,0-1.052,0.471-1.052,1.055c0,0.58,0.473,1.052,1.052,1.052h9.149 c0.58,0,1.053-0.472,1.053-1.052C26.127,29.649,25.654,29.179,25.074,29.179z"
});

var SvgCredSolicitudIcon = function SvgCredSolicitudIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "49px",
    height: "45px",
    viewBox: "0 0 49 45",
    enableBackground: "new 0 0 49 45",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCredSolicitudIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/credSolicitud_icon.bcafea1e.svg";
export { ForwardRef as ReactComponent };